export const MENU_ITEM_LOCATION = {
  MENU: "menu",
  BREADCRUMBS: "breadcrumbs",
  HOME: "home"
};
